import { render } from "./ClientsPipeline.vue?vue&type=template&id=1cf16447&scoped=true"
import script from "./ClientsPipeline.vue?vue&type=script&lang=js"
export * from "./ClientsPipeline.vue?vue&type=script&lang=js"

import "./ClientsPipeline.vue?vue&type=style&index=0&id=1cf16447&lang=scss&scoped=true"
import "./ClientsPipeline.vue?vue&type=style&index=1&id=1cf16447&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cf16447"]])

export default __exports__